import { Button } from '../../../components/ui/button';
import { openCheckoutPageThunk } from '@common-reducers/PaymentFormThunks';
import { useAppDispatch } from '@common-reducers/hooks/store.hook';
import React, { useState } from 'react';
import CancelFlowDialog from '../cancel-flow/cancel-flow-dialog';

interface ChargebeeButtonProps {
    label: string;
    plan: string;
    seats: number;
    duration: string;
    disabled: boolean;
    variant?: 'most-popular' | 'regular' | 'outline';
    size?: 'default' | 'sm' | 'lg' | 'icon';
    className?: string;
    couponCode?: string;
    onClick?: () => void;
    /** #1024 - return true to intercept the checkout (e.g. show a confirmation); call `proceed` to continue it. */
    beforeCheckout?: (proceed: () => void) => boolean;
}

const ChargebeeButton: React.FC<ChargebeeButtonProps> = ({
    label,
    plan,
    duration,
    disabled,
    seats,
    variant = 'regular',
    size = 'default',
    className,
    couponCode,
    beforeCheckout,
}) => {
    const dispatch = useAppDispatch();
    const planId = `${plan}-USD-${duration}`;
    // BE#498 — the free/cancel path opens the fully-owned cancel flow (survey →
    // one reason-matched save offer → confirm), replacing the old plain confirm.
    const [cancelFlowOpen, setCancelFlowOpen] = useState(false);

    const openCheckout = () => {
        dispatch(openCheckoutPageThunk({
            item_price_id: planId,
            quantity: seats,
            ...(couponCode && { coupon_ids: [couponCode] }),
        }));
    };

    const startCheckout = async () => {
        if (plan.toLowerCase() === 'free') {
            setCancelFlowOpen(true);
        } else if (!beforeCheckout?.(openCheckout)) {
            openCheckout();
        }
    };

    return (
        <>
            <Button
                onClick={startCheckout}
                variant={variant}
                size={size}
                disabled={disabled}
                className={className}
            >
                {label}
            </Button>
            <CancelFlowDialog open={cancelFlowOpen} onClose={() => setCancelFlowOpen(false)} />
        </>
    );
};

export default ChargebeeButton;